module.exports = __webpack_public_path__ + "img/6880@2x.ad6baf36.png";